import { render, staticRenderFns } from "./PuntoCargaGrid.vue?vue&type=template&id=9d2fd4c4&scoped=true&"
import script from "./PuntoCargaGrid.vue?vue&type=script&lang=js&"
export * from "./PuntoCargaGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2fd4c4",
  null
  
)

/* custom blocks */
import block0 from "./PuntoCargaGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports